/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * When form was submitted
 * @export
 * @interface SubmittedAt
 */
export interface SubmittedAt {
}

/**
 * Check if a given object implements the SubmittedAt interface.
 */
export function instanceOfSubmittedAt(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubmittedAtFromJSON(json: any): SubmittedAt {
    return SubmittedAtFromJSONTyped(json, false);
}

export function SubmittedAtFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmittedAt {
    return json;
}

export function SubmittedAtToJSON(value?: SubmittedAt | null): any {
    return value;
}

